import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { OrderELockForm } from 'sections/LKSection/modules/ELockModule/components/OrderELockForm/OrderELockForm'
import { validateElockForm } from 'sections/LKSection/modules/ELockModule/components/OrderELockForm/validate'
import { ElockInfoStatus } from 'sections/LKSection/modules/ELockModule/types'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Margin } from 'components/ui'
import { Modal, Text } from 'components/uiKit'
import { getActivateOrderRoute } from 'utils/helpers/routes/getRoutes'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'

type ActivateWithoutELockModalProps = {
  orderId: number
  open: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ActivateWithoutELockModal = observer(({ orderId, open, setIsOpen }: ActivateWithoutELockModalProps) => {
  const { viewOrderUiStore, eLockUiStore } = useStore()
  const { eLockReason: uiStore } = eLockUiStore

  const navigate = useNavigate()
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const eLockInfoStatus = viewOrderUiStore.selectedOrder?.eLockInfo?.status
  const formDisabled = eLockInfoStatus === ElockInfoStatus.pending || eLockInfoStatus === ElockInfoStatus.approved

  const okButtonHandler = async () => {
    if (validateElockForm.validate(uiStore) && viewOrderUiStore.selectedOrder?.id) {
      setLoading(true)

      const res =
        eLockInfoStatus === ElockInfoStatus.remark
          ? await uiStore.updateELockReason(viewOrderUiStore.selectedOrder.id)
          : await uiStore.setELockReason(viewOrderUiStore.selectedOrder.id)

      setLoading(false)

      if (res) {
        navigate(getActivateOrderRoute(orderId))
        uiStore.reset()

        await viewOrderUiStore.getOrderList()
        viewOrderUiStore.setSelectedOrder(viewOrderUiStore.getOrder(+orderId))
      }
    }
  }

  const cancelButtonHandler = () => {
    setIsOpen(false)
    uiStore.reset()
  }

  const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

  return (
    <Modal
      title={t(getKey('Активация ПВЗ без замка'))}
      open={open}
      onOk={okButtonHandler}
      onCancel={cancelButtonHandler}
      okText={t(getKey('Перейти к активации ПВЗ'))}
      cancelText={t(getSharedKey('cancel'))}
      okButtonProps={{ loading, htmlType: 'submit', disabled: formDisabled }}
    >
      <Margin mb={16}>
        <Text>{t(getKey('Если нет возможности установить замок'))}</Text>
      </Margin>

      <OrderELockForm uiStore={uiStore} hideTitle disabled={formDisabled} />
    </Modal>
  )
})
